import { CompositButton as Composit } from './CompositButton'

export * from './CompositButton'

export const Button = Object.assign({}, { Composit })
